module.exports = __webpack_public_path__ + "img/logo.f4fa91f9.png";